import { AxiosInstance } from 'axios';
import { TApiResponse } from 'types/common';
import {
  IDataExistReferenceSystem,
  IPayload,
  IPayloadUpdate,
} from 'types/referenceSystem';

export const referenceSystemApi = (axios: AxiosInstance, url: string) => ({
  getByUserIdAndType(
    params: IPayload,
  ): TApiResponse<IDataExistReferenceSystem> {
    return axios.get(`${url}/get-by-type/${params.userType}`);
  },
  create(params: IPayload): TApiResponse<IDataExistReferenceSystem> {
    return axios.post(`${url}`, params);
  },
  checkExistCode(params: string): TApiResponse<IDataExistReferenceSystem> {
    return axios.get(`${url}/get-user-by-referral-code/${params}`);
  },
  update(
    id: string,
    payload: IPayloadUpdate,
  ): TApiResponse<IDataExistReferenceSystem> {
    return axios.patch(`${url}/${id}`, payload);
  },
});
